import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { Radio, RadioGroup } from 'cat-ecommerce-alloy';
import {
  STATUS,
  UOM,
  USER_TYPE_GUEST
} from '../../../constants/commonConstants';
import { setUnitOfMeasureCookie } from './utils';
import { useMemo } from 'react';
import { updatePreference } from '@app/store/shoppingPreferences/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getLanguageDetails } from '@app/components/pages/account/shopping-preferences/utils';

const UnitOfMeasureToggle = ({
  className,
  name,
  setUnitOfMeasure,
  showLabel = false,
  showToggle,
  unitOfMeasure,
  labelClass,
  widgetId
}) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const userType = useSelector(s => s.common?.userType);

  const isLoggedIn = userType !== null && userType !== USER_TYPE_GUEST;

  const getLanguageStatus = useSelector(s => s.footer.getLanguageStatus);
  const supportedLanguages = useSelector(s => s.footer.supportedLanguages);

  const languageOptions = useMemo(
    () =>
      getLanguageStatus === STATUS.RESOLVED
        ? getLanguageDetails(supportedLanguages)
        : [],
    [getLanguageStatus, supportedLanguages]
  );
  const handleSelectedUnitOfMeasure = value => {
    setUnitOfMeasureCookie(value);
    setUnitOfMeasure(value);
    isLoggedIn &&
      dispatch(updatePreference({ uom: value }, false, languageOptions));
  };

  return showToggle ? (
    <div className={className}>
      {showLabel && (
        <p className={cx('py-2 mb-0 text-sm u-color--DarkGray', labelClass)}>
          {t('UOM')}
        </p>
      )}
      <RadioGroup
        className="mb-3 flex-wrap d-flex-inline"
        selected={unitOfMeasure}
        setSelected={handleSelectedUnitOfMeasure}
        variant="button"
      >
        <Radio
          className="m-0"
          id={`unitOfMeasure0-${widgetId}`}
          name={`unitOfMeasure_${name}`}
          label={t('UOMINCH')}
          value={UOM.us}
        />
        <Radio
          className="m-0"
          id={`unitOfMeasure1-${widgetId}`}
          name={`unitOfMeasure_${name}`}
          label={t('UOMMETRIC')}
          value={UOM.metric}
        />
      </RadioGroup>
    </div>
  ) : null;
};

UnitOfMeasureToggle.propTypes = {
  className: PropTypes.string,
  labelClass: PropTypes.string,
  name: PropTypes.string.isRequired,
  setUnitOfMeasure: PropTypes.func.isRequired,
  showLabel: PropTypes.bool,
  showToggle: PropTypes.bool.isRequired,
  unitOfMeasure: PropTypes.string.isRequired
};

export default UnitOfMeasureToggle;
